export default __webpack_public_path__ + "static/media/ford.a20be39b.svg";